import React from 'react';
import { Modal, IconButton, SelectionMode } from '@fluentui/react';
import { CampaignShimmeredDetailsList } from '@bingads-webui-grid/campaign-details-list';

import { iconButtonStyles, contentStyles } from './report-grid-modal-style';

export const ReportGridModal = (props) => {
  const {
    isReportModalOpen, hideModal, i18n, items, columns, onSort, sortedColumn, pager, onPageChange, onPageSizeChange, isLoadedAndNoDataFound
  } = props;

  function renderPlaceholderModal() {
    return (
      <div className={`${contentStyles.noDataplaceHolder} collapsed-rows-report-details-no-data`}>
        {i18n.getString(_TL_('No URLs match selected criteria.'))}
      </div>
    );
  }

  return (
    <Modal
      isOpen={isReportModalOpen}
      onDismiss={hideModal}
      isModeless
      containerClassName={contentStyles.container}
    >
      <div className={contentStyles.header}>
        <h2 className={contentStyles.heading}>
          {i18n.getString(_TL_('Other URLs'))}
        </h2>
        <IconButton
          styles={iconButtonStyles}
          iconProps={{ iconName: 'Cancel' }}
          ariaLabel="Close popup modal"
          onClick={hideModal}
        />
      </div>
      <div className={contentStyles.body}>
        <CampaignShimmeredDetailsList
          stickyHeader
          items={items || []}
          columns={columns}
          selectionMode={SelectionMode.none}
          enableShimmer={!items}
          onSort={column => onSort(column)}
          sortedColumn={sortedColumn}
          freezingColumnCount={1}
          pager={{
            ...pager,
            onPageChange,
            onPageSizeChange,
          }}
          isSortedDescendingByDefault={false}
          isGridScrollable
        />
      </div>
      {isLoadedAndNoDataFound && renderPlaceholderModal()}
    </Modal>
  );
};
